import VideoAreaParticipantItem from "./ParticipantItem";
import { useEffect, useState } from "react";
import VideoAreaBottomControlls from "./BottomControlls";
import { useSelector } from "react-redux";

export default function VideoArea({
  participants,
  focused_participant,
  setFocusedParticipant,
  playVideo,
  getAdminId,

  // streaming control
  localStream,
  localStreamScreen,
  enableVideoStream,
  handleEnableVideoStream,
  enableAudioStream,
  handleEnableAudioStream,
  // share screen control
  localScreen,
  isShareScreen,
  handleStartScreenShare,
  handleDisconnectScreenShare,

  handleDisconnect,
  messageWarning,
  // right content control
  show_chat,
  setShowChat,
  show_info,
          setShowInfo,
  show_participants,
  setShowParticipants,
  closeCall,
  processo
}) {
  const [force_row_direction, setForceRowDirection] = useState(false);

  useEffect(() => {
    // row direction with 2 participants because it's better to see
    if (Object.keys(participants).length === 2) {
      setForceRowDirection(true);
    } else {
      setForceRowDirection(false);
    }
  }, [participants]);
  const user = useSelector(store => store.AppReducer.user);
  console.log('keys',Object.keys(participants));
  return (
    <div
      style={{
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        padding: "1rem",
      }}
    >
      {!(user?.accessibility==true && user?.type_supervisor!='none' && processo?.is_interview==false) && <div id="timer_exam" style={{borderRadius:5,padding:2,display:'flex',justifyContent:'center',alignItems:'center',background:'white',fontWeight:'bold'}}>Tempo de Avaliação: 00:00:00</div>}

      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: force_row_direction ? "row" : "column",
          flexWrap: "wrap",
          gap: "1rem",
          overflow: "hidden",
        }}
      >
        {Object.keys(participants).map((key, index) => {
          let minus=0;
          // if(participants[key].id==user.id){
          //   return;
          // }
          // else if(user.accessibility==true && user.type_supervisor!='none'){
          //   minus=1;
          // }
          let row_grid = 0;

          if(focused_participant==null || focused_participant[participants[key].id]!=undefined){
          const participants_count = Object.keys(participants).length-minus;

          if (participants_count % 2 === 0) {
            row_grid = participants_count;
          } else {
            row_grid = participants_count - 1;
          }

          return (
            <VideoAreaParticipantItem
              key={index}
              {...{
                getAdminId,
                row_grid,
                participant: participants[key],
                participants,
                focused_participant,
                setFocusedParticipant,
                playVideo,
                localScreen,
                localStreamScreen,
                isShareScreen,
                index,
                participants_count,
                processo
              }}
            />
          );
        }
        })}
        {/* {user.accessibility==true && user.type_supervisor!='none' && Object.keys(participants).length==1 && <p
          style={{
            backgroundColor: 'black',
            color: "white",
            fontWeight: "bold",
            padding: "0.2rem 0.5rem",
            borderRadius: "0.5rem",
            textAlign:'center',
            marginTop:'45%'
          }}
        >
          {'Esperando fiscal...'} {Object.keys(participants).length}
        </p>} */}
      </div>
      {messageWarning!='' && <p style={{fontSize:16,color:'red',textAlign:'center'}}>{messageWarning}</p>}
      <VideoAreaBottomControlls
        {...{
          // streaming control
          localStream,
          enableVideoStream,
          handleEnableVideoStream,
          enableAudioStream,
          handleEnableAudioStream,
          isShareScreen,
          handleStartScreenShare,
          handleDisconnectScreenShare,
          handleDisconnect,
          closeCall,
          // right content control
          show_info,
          setShowInfo,
          show_chat,
          setShowChat,
          show_participants,
          setShowParticipants,
          processo
        }}
      />
    </div>
  );
}
